module.exports = __webpack_public_path__ + "img/6.e238bc2c.png";